export default __webpack_public_path__ + "static/media/4.29f14cee.png";